<div class="db-subscription-info">
  <div class="text-left">
    <h1>{{ 'text_subscriptionPlan' | dbText }}: </h1>
    <h5>{{subscription?.title || subscription?.subscriptionTitle || subscription?.subscriptionOriginalTitle}}</h5>
  </div>
  <div class="text-right">
    <h1>
      <ng-container *ngIf="isCurrencyBeforeAmount">
        {{currencySymbol}}{{
        ((subscription?.lifetimeCoupon ? subscription?.plan?.priceDiscounted : (subscription?.discountPercent ?
            subscription?.amountWithoutDiscount : subscription?.plan?.planPrice))) | negativeToZero
        }}
      </ng-container>
      <ng-container *ngIf="!isCurrencyBeforeAmount">
        {{
        ((subscription?.lifetimeCoupon ? subscription?.plan?.priceDiscounted : (subscription?.discountPercent ?
            subscription?.amountWithoutDiscount : subscription?.plan?.planPrice))) | negativeToZero
        }} {{currencySymbol}}
      </ng-container>
      <span>{{ (subscription?.plan?.periodNumber === 1 ? 'text_perMonth' : 'text_perYear') | dbText }}</span>
    </h1>
    <p class="mt8">
      {{ (subscription?.plan?.periodNumber === 1 ? 'text_billedMonthly' : 'text_billedAnnually') | dbText}}
      @if(subscription?.discountPercent && subscription?.plan?.periodNumber === 12 && !showPeriodToggle){
          <span class="discount ml8">- {{ subscription?.discountPercent | DbNumberParseFloatPipe }}%</span>
      }
    </p>
  </div>
</div>

<!-- Period toggle using checkout-change-plan structure -->
@if (showPeriodToggle && monthlyPlan && yearlyPlan) {
  <div class="db-plan-period-switcher mt16">
    <div class="db-switch__input">
      <!-- Monthly Option -->
      <div class="db-option db-monthly" [class.active]="selectedPeriod === 'monthly'" (click)="changePlan('monthly')">
        <span class="db-option-text">{{'text_periodMonthly' | dbText}}</span>
      </div>

      <!-- Annual Option -->
      <div class="db-option db-yearly" [class.active]="selectedPeriod === 'yearly'" (click)="changePlan('yearly')">
        <span class="db-option-text">{{'text_periodYearly' | dbText}}</span>
      </div>
    </div>

    <!-- Save Offer Text Outside the Switch -->
      @if (yearlyPlan?.discountAmount || yearlyPlan?.discountPercent) {
          <div class="save-offer-text">
              <b>{{ yearlyPlan?.discountPercent ? ('Save up to ' + (yearlyPlan?.discountPercent | DbNumberParseFloatPipe) + '%') : 'Save up to 50%' }}</b> with Annual
          </div>
      }
  </div>
}

<ng-template #tooltipRef>
  <ul class="tooltip-info">
      <li *ngFor="let info of planInfo">
          <i class="db-icon db-icon-ds-checkmark-small-sharp"></i>
          <p [innerHTML]="info?.feature || info?.subFeature"></p>
      </li>
  </ul>
</ng-template>
